import { create } from "zustand";
import { devtools } from "zustand/middleware";

type State = {
    isOpen: boolean;
    userId?: string;
};

type Action = {
    openEmailNotificationModal: (emailId?: string) => void;
    closeEmailNotificationModal: () => void;
};

const initialState: State = {
    isOpen: false,
};

export const useNotificationsStore = create(
    devtools<State & Action>((set) => ({
        ...initialState,

        openEmailNotificationModal: (userId) => set({ isOpen: true, userId }),
        closeEmailNotificationModal: () =>
            set({ isOpen: false, userId: undefined }),
    }))
);
